import { AppShell, Anchor, Group, Title } from "@mantine/core";
import { NavLink, Outlet } from "react-router";

export function App() {
  return (
    <AppShell header={{ height: 56 }} padding="md">
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Title order={4}>cogcoin explorer</Title>
          <Group gap="md">
            <Anchor component={NavLink} to="/domains">
              Domains
            </Anchor>
          </Group>
        </Group>
      </AppShell.Header>
      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
